import React from 'react';
import PropTypes from 'prop-types';
import { Grid as Grid$1 } from '@vds-core/grids';
import { LayoutTokens } from '@vds-tokens/layout';

const propTypes = {
  /**
   * When passed, will set the global spacing between all cols components for tablet and desktop viewports.
   */
  gutterWidth: PropTypes.oneOf(['40px', '24px']),
  /**
   * This is the max width for the Grid container, defaults to 1440.
   */
  bleed: PropTypes.oneOf(['1440', 'full'])
};
const defaultProps = {
  gutterWidth: '40px',
  bleed: '1440'
};
const Grid = function (props) {
  return React.createElement(Grid$1, Object.assign({}, props, {
    minDesktop: "1024px",
    mobileGutter: LayoutTokens.space['3X'].value,
    mobileRowInset: "10px"
  }));
};
Grid.propTypes = propTypes;
Grid.defaultProps = defaultProps;

export { Grid as default };
